import { render, staticRenderFns } from "./DvKnowledgeGraph.vue?vue&type=template&id=f047faa6&scoped=true&"
import script from "./DvKnowledgeGraph.vue?vue&type=script&lang=js&"
export * from "./DvKnowledgeGraph.vue?vue&type=script&lang=js&"
import style0 from "./DvKnowledgeGraph.vue?vue&type=style&index=0&id=f047faa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047faa6",
  null
  
)

export default component.exports